/* =========================================================
   EGODRIFT Collection Products
   Version: 1.0.0

   Progressive enhancement for the EGO Collection Products section.
   The Load More control remains a normal link when JavaScript is unavailable.
========================================================= */

(() => {
  const SECTION_SELECTOR = '[data-ego-collection-products]';
  const GRID_SELECTOR = '[data-ego-collection-grid]';
  const PAGINATION_SELECTOR = '[data-ego-collection-pagination]';
  const LOAD_MORE_SELECTOR = '[data-ego-load-more]';
  const COUNT_VISIBLE_SELECTOR = '[data-ego-collection-visible-count]';

  function getSectionFromTarget(target) {
    return target ? target.closest(SECTION_SELECTOR) : null;
  }

  function setLoading(section, link, isLoading) {
    if (!section || !link) return;

    if (isLoading) {
      if (!link.dataset.originalText) {
        link.dataset.originalText = link.textContent.trim();
      }

      section.classList.add('is-loading-more');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('aria-busy', 'true');
      link.textContent = link.dataset.loadingText || 'Loading…';
    } else {
      section.classList.remove('is-loading-more');
      link.removeAttribute('aria-disabled');
      link.removeAttribute('aria-busy');

      if (link.dataset.originalText) {
        link.textContent = link.dataset.originalText;
      }
    }
  }

  function updateVisibleCount(section) {
    const visibleCount = section.querySelector(COUNT_VISIBLE_SELECTOR);
    const grid = section.querySelector(GRID_SELECTOR);

    if (!visibleCount || !grid) return;

    visibleCount.textContent = grid.children.length.toString();
  }

  async function loadMore(event) {
    const link = event.target.closest(LOAD_MORE_SELECTOR);
    if (!link) return;

    const section = getSectionFromTarget(link);
    const grid = section ? section.querySelector(GRID_SELECTOR) : null;
    const pagination = section ? section.querySelector(PAGINATION_SELECTOR) : null;

    if (!section || !grid || !pagination || link.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    setLoading(section, link, true);

    try {
      const response = await fetch(link.href, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) throw new Error(`Failed to load collection page: ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = doc.getElementById(section.id);
      const nextGrid = nextSection ? nextSection.querySelector(GRID_SELECTOR) : null;
      const nextPagination = nextSection ? nextSection.querySelector(PAGINATION_SELECTOR) : null;

      if (!nextGrid) {
        window.location.href = link.href;
        return;
      }

      Array.from(nextGrid.children).forEach((item) => {
        grid.appendChild(document.importNode(item, true));
      });

      if (nextPagination) {
        pagination.innerHTML = nextPagination.innerHTML;
      } else {
        pagination.remove();
      }

      updateVisibleCount(section);
    } catch (error) {
      console.error(error);
      window.location.href = link.href;
    } finally {
      const updatedLink = section.querySelector(LOAD_MORE_SELECTOR);
      setLoading(section, updatedLink || link, false);
    }
  }

  document.addEventListener('click', loadMore);
})();
